export enum ApiErrorCode {
    OrganizationSuspended = "ORGANIZATION_SUSPENDED",
}
